// extracted by mini-css-extract-plugin
module.exports = {"TextArea":"TextArea__femcf","TextArea--customize":"TextArea--customize__2iOHU"};